const ProgramActionTypes = {
  SET_SEARCH_PROGRAM_FIELD: 'SET_SEARCH_PROGRAM_FIELD',
  REMOVE_SEARCH_PROGRAM_FIELD: 'REMOVE_SEARCH_PROGRAM_FIELD',
}

export default ProgramActionTypes
